import { atom } from 'jotai'
import {
    InjuredPedestrian,
    InjuredPerson,
    OtherPartyInjuredPerson,
    Witness,
} from '~/types'
import * as z from 'zod'
import {
    aboutYouValidator,
    aboutDriverValidator,
    whatHappenedValidator,
} from '~/lib/zod/bb/motor/collision-other-vehicle/validator'

type AboutYou = z.infer<typeof aboutYouValidator>
type AboutDriver = z.infer<typeof aboutDriverValidator>
export type WhatHappened = z.infer<typeof whatHappenedValidator>

export const aboutYouAtom = atom<Partial<AboutYou>>({})
export const aboutDriverAtom = atom<Partial<AboutDriver>>({})
export const whatHappenedAtom = atom<Partial<WhatHappened>>({})
export const aboutVehicleAtom = atom({})
export const damageDetailsAtom = atom({})
export const otherDetailsAtom = atom({})

export const otherPartyVehicleAtom = atom<Witness[]>([])
export const injuredPersonAtom = atom<InjuredPerson[]>([])
export const otherInjuredPersonAtom = atom<OtherPartyInjuredPerson[]>([])
export const pedestrianAtom = atom<InjuredPedestrian[]>([])
export const witnessAtom = atom<Witness[]>([])

export const allFilesAtom = atom<File[]>([])
export const retainDriverData = atom<boolean>(false)
